/* tslint:disable:no-console */
var MockTracker = /** @class */ (function () {
    function MockTracker() {
    }
    MockTracker.prototype.event = function (type, data) {
        console.log(type, data);
    };
    return MockTracker;
}());
export { MockTracker };
